// French for the events of the core library (EVENT_LIBRARY) and for the calendar templates (calendar()).
// Library events are keyed by identifier, with their stages in order; calendar events (ids `cal-YYYYMMDD-HHMM`) are
// keyed by the English name of their template. Events written by players are never translated.
export interface EventText { name: string; desc: string; stages: { name: string; desc?: string }[] }

export const libraryEvents: Record<string, EventText> = {
  'tour-gruvetto': {
    name: 'Tour de Gruvetto',
    desc: 'Six étapes, quatre maillots. Un critérium pour les sprinteurs, des collines, un contre-la-montre, le Col des Nuages, une élimination et le final en ville.',
    stages: [
      { name: 'Critérium d’ouverture', desc: 'Plat et nerveux : les sprinteurs prennent le vert.' },
      { name: 'Les Collines', desc: 'Une côte à chaque tour, les puncheurs attaquent.' },
      { name: 'Contre-la-montre du Mur', desc: 'Seul contre la montre, sans objets ni aspiration.' },
      { name: 'Étape reine : Col des Nuages', desc: 'Trois passages au sommet, le maillot à pois se joue ici.' },
      { name: 'Élimination des Collines', desc: 'Le dernier de chaque tour est éliminé. Écarts par rang.' },
      { name: 'Final en ville', desc: 'Le sprint de la dernière étape, sur les grands boulevards.' },
    ],
  },
  'triptyque-monts': {
    name: 'Triptyque des Monts',
    desc: 'Trois jours pour les grimpeurs : le Mur, un contre-la-montre en côte et un final au Col des Nuages.',
    stages: [{ name: 'Le Mur' }, { name: 'Contre-la-montre en côte' }, { name: 'Les Nuages' }],
  },
  'coupe-kart': {
    name: 'Coupe Arcade',
    desc: 'Quatre manches, trois modes : Grand Prix, contre-la-montre, élimination et une finale. Classement aux points comme un championnat.',
    stages: [{ name: 'Manche 1 · Grand Prix' }, { name: 'Manche 2 · Contre-la-montre' }, { name: 'Manche 3 · Élimination' }, { name: 'Finale' }],
  },
  'gp-sprinteurs': {
    name: 'Grand Prix des Sprinteurs',
    desc: 'Cinq tours du critérium, quatre sprints intermédiaires : chaque passage sur la ligne rapporte des points.',
    stages: [{ name: 'Grand Prix' }],
  },
};

export const calendarEvents: Record<string, EventText> = {
  'Criterium sprint': { name: 'Critérium sprint', desc: 'Critérium rapide, trois sprints intermédiaires.', stages: [{ name: 'Critérium' }] },
  'Cloud Pass climb': { name: 'Ascension du Col des Nuages', desc: 'Deux passages au sommet du Col des Nuages.', stages: [{ name: 'Col des Nuages' }] },
  'Evening elimination': { name: 'Élimination du soir', desc: 'Le dernier de chaque tour est éliminé.', stages: [{ name: 'Élimination' }] },
  'Hills time trial': { name: 'Contre-la-montre des Collines', desc: 'Contre-la-montre : ni objets, ni aspiration.', stages: [{ name: 'Contre-la-montre' }] },
  'Rookie Grand Prix': { name: 'Grand Prix des débutants', desc: 'Une course courte avec objets pour les nouveaux, deux tours.', stages: [{ name: 'Grand Prix' }] },
  'Hills Grand Prix': { name: 'Grand Prix des Collines', desc: 'Course classique avec objets, trois tours.', stages: [{ name: 'Grand Prix' }] },
};

/** Custom jersey names used by library events, by exact English text. */
export const eventJerseys: Record<string, string> = { 'Leader’s jersey': 'Maillot de leader' };
